import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared.module';
import { WidgetsComponentsModule } from 'src/app/components/kit/widgets/widgets-components.module';
import { WorkflowModule } from '../../workflow.module';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { ReportComponent } from './report.component';
import { ListReportComponent } from './list-report/list-report.component';
import { ReportCardComponent } from '@workflow/components/report-card/report-card.component';
import { ElementsModule } from '@app/components/elements/elements.module';
import { MarkdownModule } from 'ngx-markdown';
import { ContentBlockReportComponent } from '@workflow/components/report/content-block-report/content-block-report.component';
import { BfsGraphReportComponent } from './bfs-graph-report/bfs-graph-report.component';

const COMPONENTS = [
	ReportComponent,
	ListReportComponent,
	ReportCardComponent,
	ContentBlockReportComponent
];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		SharedModule,
		WidgetsComponentsModule,
		WorkflowModule,
		ElementsModule,
		MarkdownModule,
	],
	exports: [
		ReportComponent,
		ReportCardComponent,
	],
	declarations: [...COMPONENTS, BfsGraphReportComponent],
	providers: [
		DatePipe,
		DecimalPipe
	],
})
export class ReportModule {}
